'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_TypeInfo(owner, short, typeParams) {
  this.sl = null;
  this.mi = null;
  this.wd = null;
  this.sl = owner;
  this.mi = short;
  this.wd = typeParams;
}
export { $c_Lmagnolia1_TypeInfo as $c_Lmagnolia1_TypeInfo };
$p = $c_Lmagnolia1_TypeInfo.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_TypeInfo;
/** @constructor */
function $h_Lmagnolia1_TypeInfo() {
}
export { $h_Lmagnolia1_TypeInfo as $h_Lmagnolia1_TypeInfo };
$h_Lmagnolia1_TypeInfo.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmagnolia1_TypeInfo)) {
    if (((this.sl === x$0.sl) && (this.mi === x$0.mi))) {
      var x = this.wd;
      var x$2 = x$0.wd;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 3;
});
$p.o = (function() {
  return "TypeInfo";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sl;
      break;
    }
    case 1: {
      return this.mi;
      break;
    }
    case 2: {
      return this.wd;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.BB = (function() {
  return ((this.sl + ".") + this.mi);
});
function $isArrayOf_Lmagnolia1_TypeInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e6)));
}
export { $isArrayOf_Lmagnolia1_TypeInfo as $isArrayOf_Lmagnolia1_TypeInfo };
var $d_Lmagnolia1_TypeInfo = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_TypeInfo, "magnolia1.TypeInfo", ({
  e6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmagnolia1_TypeInfo as $d_Lmagnolia1_TypeInfo };
